import { DEFAULT_GAME_ID, BET_LIMIT_TYPES } from 'constants/index'

export const CASH_GAME_VARIANT_OPTIONS = [
  { id: String(DEFAULT_GAME_ID.POKER_TEXAS_HOLDEM), label: "Hold'em", value: DEFAULT_GAME_ID.POKER_TEXAS_HOLDEM },
  { id: String(DEFAULT_GAME_ID.POKER_OMAHA_PLO_4), label: 'PLO4', value: DEFAULT_GAME_ID.POKER_OMAHA_PLO_4 },
  { id: String(DEFAULT_GAME_ID.POKER_OMAHA_PLO_5), label: 'PLO5', value: DEFAULT_GAME_ID.POKER_OMAHA_PLO_5 },
  { id: String(DEFAULT_GAME_ID.POKER_OMAHA_PLO_6), label: 'PLO6', value: DEFAULT_GAME_ID.POKER_OMAHA_PLO_6 },
  { id: String(DEFAULT_GAME_ID.POKER_SHORT_DECK), label: 'Short Deck', value: DEFAULT_GAME_ID.POKER_SHORT_DECK }
]

export const gameIdToCashGameType = (gameId) => {
  const id = Number(gameId)
  if (id === DEFAULT_GAME_ID.POKER_SHORT_DECK) return 'SHORT_DECK'
  if (
    id === DEFAULT_GAME_ID.POKER_OMAHA_PLO_4 ||
    id === DEFAULT_GAME_ID.POKER_OMAHA_PLO_5 ||
    id === DEFAULT_GAME_ID.POKER_OMAHA_PLO_6
  ) {
    return 'PLO'
  }
  return 'NLH'
}

export const gameIdToPotLimitType = (gameId) =>
  gameIdToCashGameType(gameId) === 'PLO'
    ? BET_LIMIT_TYPES.POT_LIMIT
    : BET_LIMIT_TYPES.NO_LIMIT

/** @deprecated Prefer selecting gameId directly (Hold'em / PLO5 / PLO6). */
export const cashGameTypeToDefaultGameId = (gameType) =>
  gameType === 'PLO' ? DEFAULT_GAME_ID.POKER_OMAHA_PLO_5 : DEFAULT_GAME_ID.POKER_TEXAS_HOLDEM

export const gameIdToVariantLabel = (gameId) => {
  const option = CASH_GAME_VARIANT_OPTIONS.find((row) => Number(row.value) === Number(gameId))
  return option?.label || '—'
}
